import React, { useState } from 'react';
import { ImageWrapper, ImageElement } from './Image.styled';

interface Props {
  src: string;
  alt?: string;
  aspectRatio?: string;
  srcSet?: string;
  sizes?: string;
  width?: number;
  height?: number;
  fallbackSrc?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}

export const Image = React.memo(
	({
		src,
		alt = 'Image',
		aspectRatio = '16/9',
		srcSet,
		sizes = '100vw',
		width,
		height,
		fallbackSrc = 'https://files.static.plecto.com/images/Astro%20empty%20state/Variant%3DTemplates.svg',
		objectFit = 'cover',
	}: Props) => {
		const [imageSrc, setImageSrc] = useState(src);

		return (
			<ImageWrapper $aspectRatio={aspectRatio}>
				<ImageElement
					srcSet={srcSet}
					sizes={sizes}
					src={imageSrc}
					alt={alt}
					width={width}
					height={height}
					loading="lazy"
					decoding="async"
					$objectFit={objectFit}
					onError={() => setImageSrc(fallbackSrc)}
				/>
			</ImageWrapper>
		);
	}
);

Image.displayName = 'Image';
